import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';

const checkValues = ['Item ', 'Item 4'];
const questions = ['domanda13'];

export const getIndicators = (submissions: ISubmissionProps[]) => {
    const values = {
        total: submissions.length,
        training: 0,
    };

    submissions.forEach(submission => {
        let found: Record<string, boolean> = Object.fromEntries(questions.map(key => [key, false]));

        Object.entries(submission).forEach(([question, value]) => {
            if (typeof value === 'string') {
                const key = questions.find(k => question.startsWith(k));
                if (key && checkValues.includes(value)) {
                    found[key] = true;
                }
            }
        });

        const validaLength = Object.values(found).filter(el => el).length;
        const totalLength = Object.values(found).length;

        if (validaLength === totalLength) {
            values.training++;
        }
    });

    if (values.total > 0) {
        return Number((values.training / values.total * 100).toFixed(2));
    }

    return 0;
}